var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _vm.transaction
        ? _c("v-repeat-load-group-dialog", {
            attrs: {
              loadGroupId: _vm.loadGroupId,
              sponsor: _vm.loadGroupSponsorName(_vm.loadGroup),
              origin: _vm._f("originName")(_vm.loadGroup.details),
              destination: _vm._f("destinationName")(_vm.loadGroup.details),
              count: _vm.loadGroup.loadCount || 1,
              isMobile: _vm.isMobile,
              loading: _vm.loadingBtn,
              company: _vm.company,
              "load-group": _vm.loadGroup
            },
            on: {
              cancel: _vm.closeCopyLoadDialog,
              newLoad: function($event) {
                return _vm.closeCopyLoadDialog(true)
              }
            },
            model: {
              value: _vm.showCopyLoadDialog,
              callback: function($$v) {
                _vm.showCopyLoadDialog = $$v
              },
              expression: "showCopyLoadDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.transaction
        ? _c(
            "v-toolbar",
            { attrs: { height: "56" } },
            [
              _c("v-toolbar-title", [
                _vm._v("\n      " + _vm._s(_vm.bannerTitle) + "\n    ")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.transaction
        ? _c(
            "v-toolbar",
            { attrs: { height: "58" } },
            [
              _c("v-toolbar-title", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.transaction.loadHumanId) +
                    ", $" +
                    _vm._s(_vm.transaction.amount) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  attrs: { slot: _vm.isMobile ? "extension" : null },
                  slot: _vm.isMobile ? "extension" : null
                },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            flat: "",
                            color: "primary",
                            loading: _vm.updatingTransaction
                          },
                          on: {
                            click: function($event) {
                              return _vm.refreshTransaction(_vm.transaction)
                            }
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c("v-icon", [_vm._v("refresh")]),
                              _vm._v("\n            Reload\n          ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tabs",
                        {
                          attrs: {
                            right: !_vm.isMobile,
                            centered: _vm.isMobile,
                            grow: "",
                            "show-arrows": "",
                            color: "#f5f5f5",
                            "slider-color": "primary"
                          },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c(
                            "v-tab",
                            { key: "Details" },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "align-center",
                                  attrs: { column: "" }
                                },
                                [
                                  _c("v-icon", [_vm._v("local_atm")]),
                                  _vm._v(
                                    "\n              Details\n            "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            { key: "Load" },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "align-center",
                                  attrs: { column: "" }
                                },
                                [
                                  _c("v-icon", [_vm._v("list")]),
                                  _vm._v("\n              Load\n            ")
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            { key: "History" },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "align-center",
                                  attrs: { column: "" }
                                },
                                [
                                  _c("v-icon", [_vm._v("timeline")]),
                                  _vm._v(" "),
                                  _vm.loadingTransactionHistory
                                    ? _c("v-progress-linear", {
                                        staticClass: "mt-2 mb-0",
                                        attrs: { indeterminate: true }
                                      })
                                    : [
                                        _vm._v(
                                          "\n                History\n              "
                                        )
                                      ]
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            { key: "Map" },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "align-center",
                                  attrs: { column: "" }
                                },
                                [
                                  _c("v-icon", [_vm._v("map")]),
                                  _vm._v("\n              Map\n            ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pt-1", class: { "scroll-section": !_vm.isMobile } },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _vm.tab != null
                ? _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c(
                        "v-tab-item",
                        {
                          key: "Details",
                          attrs: {
                            transition: false,
                            "reverse-transition": false
                          }
                        },
                        [
                          _c("v-load-transaction-status-details", {
                            staticClass: "mt-2",
                            attrs: {
                              "multi-transaction-export":
                                _vm.isMultiTransactionExportModeEnabled,
                              company: _vm.company,
                              invoice: _vm.invoice,
                              bill: _vm.bill,
                              transaction: _vm.transaction
                            },
                            on: {
                              "reset-selected": function($event) {
                                return _vm.$emit("reset-selected")
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "Load",
                          attrs: {
                            transition: false,
                            "reverse-transition": false
                          }
                        },
                        [
                          _vm.transaction
                            ? _c(
                                "v-edit-load-details",
                                {
                                  attrs: {
                                    company: _vm.company,
                                    transaction: "",
                                    "planning-load":
                                      _vm.transaction.load.tacticalInfo
                                  },
                                  on: {
                                    refresh: function($event) {
                                      return _vm.$emit("updateLoad", $event)
                                    },
                                    savingLoad: function($event) {
                                      return _vm.$emit("savingLoad", $event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-toolbar-items",
                                    {
                                      attrs: { slot: "toolbarItems" },
                                      slot: "toolbarItems"
                                    },
                                    [
                                      _vm._t("toolbarButtons", function() {
                                        return [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                flat: "",
                                                color: "accent"
                                              },
                                              on: {
                                                click: _vm.openCopyLoadDialog
                                              }
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                { attrs: { column: "" } },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("redo")
                                                  ]),
                                                  _vm._v(
                                                    "\n                    Repeat\n                  "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "History",
                          attrs: {
                            transition: false,
                            "reverse-transition": false
                          }
                        },
                        [
                          _c("v-load-transaction-histories", {
                            attrs: {
                              company: _vm.company,
                              transaction: _vm.transaction
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "Map",
                          attrs: {
                            transition: false,
                            "reverse-transition": false
                          }
                        },
                        [
                          _vm._t("loadMap", function() {
                            return [
                              _vm.transaction
                                ? _c("load-map", {
                                    staticClass: "py-1 px-1",
                                    attrs: {
                                      hideOnSmall: "",
                                      load: _vm.transaction.load,
                                      "origin-place-id": _vm._.get(
                                        _vm.transaction,
                                        "load.tacticalInfo.loadGroup.details.pickupLocation.googlePlace.placeId",
                                        null
                                      ),
                                      "destination-place-id": _vm._.get(
                                        _vm.transaction,
                                        "load.tacticalInfo.loadGroup.details.dropoffLocation.googlePlace.placeId",
                                        null
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-943e5fe8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-943e5fe8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/simple/LoadTransactionDetails.vue
// module id = null
// module chunks = 